import { api } from './api';
import {
  LotesResponse,
  EstadisticasLotes,
  LoteIngredienteBackend,
} from '../types/lotes';

export interface LoteParams {
  ingredienteId?: number;
  /** Filtro por nombre normalizado (case-insensitive, trim). Agrupa variantes de escritura del mismo ingrediente. */
  ingredienteNombre?: string;
  estado?: string;
  proximoVencer?: boolean;
  ordenCompraId?: number;
  page?: number;
  limit?: number;
}

export interface CrearLoteData {
  ingredienteId: number;
  numeroLote: string;
  cantidad: number;
  fechaVencimiento?: string;
  precioUnitario: number;
  proveedorId: number;
  observaciones?: string;
}

export interface ActualizarLoteData {
  cantidadDisponible: number;
  observaciones?: string;
}

class LotesAPI {
  async listar(params?: LoteParams): Promise<LotesResponse> {
    const response = await api.get('/lotes', { params });
    return response.data;
  }

  async obtener(id: string): Promise<LoteIngredienteBackend> {
    const response = await api.get(`/lotes/${id}`);
    return response.data;
  }

  async obtenerPorIngrediente(ingredienteId: number): Promise<LotesResponse> {
    const response = await api.get(`/lotes/ingrediente/${ingredienteId}`);
    return response.data;
  }

  async obtenerEstadisticas(
    ingredienteId?: number
  ): Promise<EstadisticasLotes> {
    const params = ingredienteId ? { ingredienteId } : {};
    const response = await api.get('/lotes/estadisticas', { params });
    return response.data;
  }

  async obtenerIngredientesConLotes(): Promise<
    {
      nombre_key: string;
      nombre_sample: string;
      lotes_count: number;
      variantes_count: number;
    }[]
  > {
    const response = await api.get('/lotes/ingredientes-filtro');
    return response.data?.data ?? [];
  }

  async crear(data: CrearLoteData) {
    const response = await api.post('/lotes', data);
    return response.data;
  }

  async actualizar(id: string, data: ActualizarLoteData) {
    const response = await api.put(`/lotes/${id}`, data);
    return response.data;
  }

  /**
   * Actualiza la fecha de vencimiento de un lote.
   *
   * Va contra `/lotes-ingredientes/:id`, que es el router que expone el
   * update real; `/lotes/:id` no tiene handler PUT en el backend. Pasar
   * `null` borra la fecha (lote sin vencimiento).
   */
  async actualizarVencimiento(id: number, fechaVencimiento: string | null) {
    const response = await api.put(`/lotes-ingredientes/${id}`, {
      fecha_vencimiento: fechaVencimiento,
    });
    return response.data;
  }
}

export const lotesAPI = new LotesAPI();
